export const questionTypes = {
  dropdown: 'Dropdown',
  multiple_choice: 'MultipleChoice',
  short_text: 'ShortText',
  ranking: 'Ranking',
  rating: 'Rating',
  open_text: 'Text',
  response: 'Response',
};
